// LoadingAnimation.jsx
import React from 'react';
import { FaChessKing } from 'react-icons/fa';

const LoadingAnimation = () => {
  return (
    <div role="status" className="flex min-h-48 flex-col items-center justify-center gap-4 p-6 text-center text-slate-600">
      <FaChessKing aria-hidden="true" className="h-10 w-10 text-[#247da8] motion-safe:animate-pulse" />
      <p className="m-0 text-base">Generating puzzles...</p>
    </div>
  );
};

export default LoadingAnimation;
